import { useState } from "react";
import {payEmiAmount} from "../../Api/Api";
import { FaTimes, FaMoneyBillWave } from "react-icons/fa";


const EMIPaymentModal = ({ emi, onClose, onPaymentSuccess }) => {
    const [paymentAmount, setPaymentAmount] = useState("");
    const [error, setError] = useState("");

    const handlePayment = async () => {
        if (!paymentAmount || parseFloat(paymentAmount) <= 0) {
            setError("Enter a valid payment amount.");
            return;
        }
        try {
            const response = await payEmiAmount(emi.id, paymentAmount)
            onPaymentSuccess(response.data);
            onClose();
        } catch (err) {
            setError("Payment failed. Please try again.");
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg p-6">
                {/* Header */}
                <div className="flex justify-between items-center border-b pb-4 mb-4">
                    <h2 className="text-2xl font-semibold text-gray-800 flex items-center">
                        <FaMoneyBillWave className="mr-2 text-green-500" /> Pay EMI
                    </h2>
                    <button onClick={onClose} className="text-gray-600 hover:text-gray-900 text-3xl">&times;</button>
                </div>

                {/* EMI Details */}
                <div className="space-y-3 text-gray-800">
                    <p><strong>EMI Amount:</strong> &#x20B9; {emi.amount}</p>
                    <p><strong>Paid Amount:</strong> &#x20B9; {emi.paidAmount}</p>
                    <p><strong>Penalty:</strong> &#x20B9; {emi.penaltyAmount}</p>
                    <p><strong>Remaining Amount:</strong> &#x20B9; {emi.remainingAmount}</p>
                    <input
                        type="number"
                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-green-500"
                        placeholder="Enter payment amount"
                        value={paymentAmount}
                        onChange={(e) => setPaymentAmount(e.target.value)}
                    />
                    {error && <p className="text-red-500 mt-2">{error}</p>}
                </div>

                {/* Footer */}
                <div className="flex justify-between mt-6">
                    <button onClick={onClose} className="px-6 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-all">Cancel</button>
                    <button onClick={handlePayment} className="px-6 py-2 bg-green-500 text-white rounded-md flex items-center hover:bg-green-600 transition-all">
                        <FaMoneyBillWave className="mr-2" /> Pay
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EMIPaymentModal;
